import { createContext, useContext, useState, useEffect } from "react";
import { auth, db } from "@/lib/firebase";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";

const AuthContext = createContext(null);

// Emails autorises comme admin
const ADMIN_EMAILS = [
  "goldenseaconciergerie@gmail.com",
];

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        setUser(firebaseUser);
        // Verifier si admin
        const adminStatus = ADMIN_EMAILS.includes(firebaseUser.email?.toLowerCase());
        setIsAdmin(adminStatus);

        // Creer/mettre a jour le document utilisateur dans Firestore
        if (adminStatus) {
          try {
            const userRef = doc(db, "users", firebaseUser.uid);
            const userDoc = await getDoc(userRef);
            if (!userDoc.exists()) {
              await setDoc(userRef, {
                email: firebaseUser.email,
                role: "admin",
                createdAt: new Date().toISOString(),
              });
            }
          } catch (err) {
            console.error("Erreur creation doc utilisateur:", err);
          }
        }
      } else {
        setUser(null);
        setIsAdmin(false);
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const login = async (email, password) => {
    const result = await signInWithEmailAndPassword(auth, email, password);
    const adminStatus = ADMIN_EMAILS.includes(result.user.email?.toLowerCase());
    if (!adminStatus) {
      await signOut(auth);
      throw new Error("Acces refuse. Ce compte n'est pas administrateur.");
    }
    return result;
  };

  const logout = async () => {
    await signOut(auth);
  };

  return (
    <AuthContext.Provider value={{ user, loading, isAdmin, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth doit etre utilise dans un AuthProvider");
  }
  return context;
}
